module.exports = __webpack_public_path__ + "img/9788990878762.ab7d09ca.jpg";